(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('ResultReportController', ResultReportController);

    ResultReportController.$inject = ['$scope', '$state', 'DataUtils', 'ResultReport', 'ResultReportSearch'];

    function ResultReportController ($scope, $state, DataUtils, ResultReport, ResultReportSearch) {
        var vm = this;

        vm.resultReports = [];
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;
        vm.search = search;

        loadAll();

        function loadAll() {
            ResultReport.query(function(result) {
                vm.resultReports = result;
            });
        }

        function search () {
            if (!vm.searchQuery) {
                return vm.loadAll();
            }
            ResultReportSearch.query({query: vm.searchQuery}, function(result) {
                vm.resultReports = result;
            });
        }    }
})();
